module.exports = __webpack_public_path__ + "img/www.dc5c33dd.svg";